// Keycloak configs
export const keycloakUrl = process.env.REACT_APP_KEYCLOAK_URL;
export const keycloakRealm = process.env.REACT_APP_KEYCLOAK_REALM;
export const keycloakClientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;

export const refreshKeycloakToken =
  process.env.REACT_APP_KEYCLOAK_REFRESH_TOKEN === "true";

// Auth service client params
export const baseAuthorizationServerUrl =
  process.env.REACT_APP_AUTH_SERVICE_URL;
export const tokenExchangeEndpoint =
  process.env.REACT_APP_TOKEN_EXCHANGE_ENDPOINT;
export const authAudience = process.env.REACT_APP_AUDIENCE;
export const grantType = process.env.REACT_APP_GRANT_TYPE;
export const subjectTokenType = process.env.REACT_APP_SUBJECT_TOKEN_TYPE;

// Other authorization service portals
export const applicationPortal = process.env.REACT_APP_APPLICATIONS_URL;

export const service_admin_role = process.env.REACT_APP_SERVICE_ADMIN_ROLE;

console.log("Setting environment as:");
console.log(process.env);
